/**
 * 静态地址
 */

// 官网地址
export const officialUrl = "https://ppt.123bot.cn";

// 客服地址
export const serviceUrl =
  "https://tb.53kf.com/code/client/e5737fde24ca205cd5bfe7a693f625822/5";
// 'https://affim.baidu.com/unique_43361933/chat?siteId=19919177&userId=43361933&siteToken=031982e192a19e0f4ecc4cf17c1b4ead';

// 本地及测试地址
export const testList = [
  "http://localhost:5173",
  "http://ppt.dev.chatnote.com.cn",
];

// gpt 接口域名
export const gptDomain = import.meta.env.VITE_GPT_DOMAIN as string;
export const pptDomain = import.meta.env.VITE_PPT_DOMAIN as string;

/**
 * api地址
 */
// axios接口域名
export const allBaseUrl: any = {
  drawApi: { url: "https://draw.server.360qnw.com", isEncode: true },
  qnwApi: { url: "https://chatdoc.api.360qnw.com", isEncode: false },
  gptApi: { url: gptDomain, isEncode: true },
  pptApi: { url: pptDomain, isEncode: true },
};

// gpt流式输出接口
export const gptApi = `${gptDomain}/api/v2/app-community-v2`;

// 移动端支付接口域名
export const mobilePayUrl = "https://p.360qnw.com";
export const wxMobilePayUrl = "https://api.360qnw.com";
